/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { hooksServerNamesDeleteServerNameOverride } from "../funcs/hooksServerNamesDeleteServerNameOverride.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteServerNameOverrideRequest,
  DeleteServerNameOverrideSecurity,
} from "../models/operations/deleteservernameoverride.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type HooksServerNamesDeleteServerNameOverrideMutationVariables = {
  request: DeleteServerNameOverrideRequest;
  security?: DeleteServerNameOverrideSecurity | undefined;
  options?: RequestOptions;
};

export type HooksServerNamesDeleteServerNameOverrideMutationData = void;

export type HooksServerNamesDeleteServerNameOverrideMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * delete hooksServerNames
 *
 * @remarks
 * Delete a server name display override
 */
export function useHooksServerNamesDeleteServerNameOverrideMutation(
  options?: MutationHookOptions<
    HooksServerNamesDeleteServerNameOverrideMutationData,
    HooksServerNamesDeleteServerNameOverrideMutationError,
    HooksServerNamesDeleteServerNameOverrideMutationVariables
  >,
): UseMutationResult<
  HooksServerNamesDeleteServerNameOverrideMutationData,
  HooksServerNamesDeleteServerNameOverrideMutationError,
  HooksServerNamesDeleteServerNameOverrideMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildHooksServerNamesDeleteServerNameOverrideMutation(client, options),
    ...options,
  });
}

export function mutationKeyHooksServerNamesDeleteServerNameOverride(): MutationKey {
  return ["@gram/client", "hooksServerNames", "deleteServerNameOverride"];
}

export function buildHooksServerNamesDeleteServerNameOverrideMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: HooksServerNamesDeleteServerNameOverrideMutationVariables,
  ) => Promise<HooksServerNamesDeleteServerNameOverrideMutationData>;
} {
  return {
    mutationKey: mutationKeyHooksServerNamesDeleteServerNameOverride(),
    mutationFn: function hooksServerNamesDeleteServerNameOverrideMutationFn({
      request,
      security,
      options,
    }): Promise<HooksServerNamesDeleteServerNameOverrideMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(hooksServerNamesDeleteServerNameOverride(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
